import './grid-button.scss'
import type { GridElement } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import { CtaButton } from '@/common/components/ctaButton/CtaButton'
import type { CtaButtonPropsApi } from '@/common/components/ctaButton/models'

/**
 * DevNote: This is basically a cta-link, but it called a button on cms, so we have to align with that
 * */
interface ButtonProps extends Omit<CtaButtonPropsApi, 'alignment'> {
    alignment: 'left' | 'center' | 'right'
}

export const Button: FC<GridElement<ButtonProps>> = ({ value }) => {
    const { alignment, ...rest } = value
    return (
        <div className={`text-${alignment ?? 'center'} grid-button-wrapper`}>
            <CtaButton {...rest} />
        </div>
    )
}
